import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from '../app.models';
import { createIsEqualSelector } from '../shared/ngrx/selector.utils';
import { tenantFeatureKey, TenantState } from './tenants.models';

const selectFeature = createFeatureSelector<TenantState>(tenantFeatureKey);

export const selectLoading = createSelector(selectFeature, (state) => state.loading > 0);
export const selectInitiallyLoaded = createSelector(selectFeature, (state) => state.initiallyLoaded);
export const selectTenants = createIsEqualSelector(selectFeature, (state: TenantState) => Array.from(state.tenants.values()));
